import { EVENTS } from '../../lib/constants';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { GameConfigs } from '../../lib/globals/GameConfigs';
class SettigsItemController {
	constructor(vc, conf) {
		this.config = conf;
		if (vc) {
			if (this.config.holder) {
				this.vc = vc[this.config.holder][this.config.item];
			} else {
				this.vc = vc[this.config.item];
			}
			this.item = this.vc[this.config.val];
			this.item.itemheader.text = window.lm[this.config.texts[0]].value;
			this.item.itemsett.text = window.lm[this.config.texts[1]].value;
			this.item.itemdesc.text = window.lm[this.config.texts[2]].value;
			this.item.switchbtn.handler = this.update.bind(this);
			this.item.switchbtn.setActive(GameConfigs.settings[this.config.val]);
			if (
				(window.isMobile || window.isTablet) &&
				this.item.name === 'keyboard_shortcuts'
			) {
				this.item.switchbtn.setActive(false);
				this.item.switchbtn.alpha = 0.5;
				this.item.switchbtn.interation = false;
				let uo = {};
				uo[this.config.val] = this.item.switchbtn.active;
				HELPERS.setSettings(uo);
			}
			this.initPositions();
			this.init();
			this.addEventListeners();
		} else {
			throw new Error(
				'SettigsItemController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	addEventListeners() {
		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.addEventListener(EVENTS.MODAL, this, false);
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.SETTINGS_UPDATE:
				this.item.switchbtn.active = GameConfigs.settings[this.config.val];
				this.init();
				break;
			case EVENTS.MODAL:
				this.removeListeners();
				break;
			case EVENTS.REEL_FINISHED:
				if (GameConfigs.win > 0) {
					HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
					this.removeListeners();
				}
				break;
			default:
				break;
		}
	}

	initPositions() {
		this.item.switchbtn.bgText.position.x = 24;
		this.item.switchbtn.fgText.position.x = 58;
		this.item.switchbtn.bgimg.position.x = 65;
		this.item.switchbtn.fgimg.position.x = 18;
	}

	init() {
		this.item.switchbtn.bg.alpha = this.item.switchbtn.active ? 1 : 0;
		this.item.switchbtn.fg.alpha = this.item.switchbtn.active ? 0 : 1;
		this.item.bgblue.alpha = this.item.switchbtn.active ? 1 : 0;
		this.item.bgred.alpha = this.item.switchbtn.active ? 0 : 1;
	}

	update() {
		if (
			(window.isMobile || window.isTablet) &&
			this.item.name === 'keyboard_shortcuts'
		) {
			this.item.interation = false;
			this.item.switchbtn.active = false;
			this.init();
			return;
		}
		const isSoundEffects = this.item.name === 'sound_effects';
		const soundEffectName = this.item.switchbtn.active
			? 'double_chance_off_sfx'
			: 'double_chance_on_sfx';

		if (isSoundEffects) {
			window.sm.playSoundSwitch({ name: soundEffectName });
		} else {
			window.sm.play({ name: soundEffectName });
		}
		this.item.switchbtn.active = !this.item.switchbtn.active;
		this.init();
		let uo = {};
		uo[this.config.val] = this.item.switchbtn.active;
		HELPERS.setSettings(uo);
	}

	removeListeners() {
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.removeEventListener(EVENTS.MODAL, this, false);
		window.removeEventListener(EVENTS.REEL_FINISHED, this, false);
	}
}

export default SettigsItemController;
